import { formatearMontoGasto } from '../../utils/gastos'

const MAXIMO_VISIBLE = 5

function RankingTerceros({
  titulo,
  subtitulo,
  filas,
  etiquetaVacia,
  etiquetaCantidad = 'documentos',
}) {
  const principales = filas.slice(0, MAXIMO_VISIBLE)

  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
      <h3 className="text-lg font-bold text-slate-900">
        {titulo}
      </h3>

      <p className="mt-1 text-sm text-slate-500">{subtitulo}</p>

      {principales.length === 0 ? (
        <p className="mt-6 text-sm text-slate-500">
          {etiquetaVacia}
        </p>
      ) : (
        <div className="mt-6 space-y-4">
          {principales.map((fila) => (
            <div key={fila.nombre}>
              <div className="flex items-center justify-between gap-3 text-sm">
                <div className="min-w-0">
                  <span className="font-semibold text-slate-800">
                    {fila.nombre}
                  </span>

                  <span className="ml-2 text-xs text-slate-400">
                    {fila.cantidad} {etiquetaCantidad}
                  </span>
                </div>

                <span className="shrink-0 text-slate-500">
                  {formatearMontoGasto(fila.total)} ·{' '}
                  {fila.porcentaje.toLocaleString('es-CL', {
                    maximumFractionDigits: 1,
                  })}
                  %
                </span>
              </div>

              <div className="mt-1.5 h-2 w-full overflow-hidden rounded-full bg-slate-100">
                <div
                  className="h-full rounded-full bg-emerald-500"
                  style={{ width: `${fila.porcentaje}%` }}
                />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default RankingTerceros
